import React from "react";
import { RectangularEaseCard, CircularEaseCard } from "./index";

const Card = ({ type, title, imageUrl }) => {
  switch (type) {
    case "rectangularEase":
      return <RectangularEaseCard title={title} imageUrl={imageUrl} />;
    case "circularEase":
      return <CircularEaseCard title={title} imageUrl={imageUrl} />;
    default:
      return <></>;
  }
};

export default Card;
